<template>
    <section id="section-start">
        <div style="display: flex;">
            <button id="start-button" class="btn form-control" type="button" @click="openTemplateModal()">
                {{ renew ? "Sessão Expirou! Por favor, selecione um template..." : "Selecione um template..." }}
            </button>

            <button v-if="!btnFinish" class="btn btn-danger chatMensagem-button" type="button" id="finalizar"
                @click.prevent="endCurrChat()">
                Finalizar
            </button>
        </div>

        <div class="modal-2" v-if="modal">
            <div class="modal-content-my">
                <form class="form-modal">
                    <div class="modal-head">
                        <h3>Selecionar Template</h3>
                        <span @click="btnClose()" class="closeBtn"><i class="fas fa-times"></i></span>
                    </div>

                    <input type="text" class="form-control m-1 input-search-temp"
                        placeholder="🔎 Pesquise pelo nome do template..." v-model="searchInput">

                    <div id="template-box">
                        <div class="template-item" v-for="el in items" @click="templateSelect(el)">
                            <span class="template-name">{{ el.name }}</span>
                            <span class="template-item-header">{{ el.header }}</span>
                            <span class="template-item-body">{{ el.body }}</span>
                            <span class="template-item-footer">{{ el.footer }}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="modal-2" v-if="parameterModal">
            <div class="modal-content-my">
                <form class="form-modal">
                    <div class="modal-head">
                        <h3>Definir parâmetros do template</h3>
                        <span @click="btnCloseParameter()" class="closeBtn"><i class="fas fa-times"></i></span>
                    </div>

                    <div class="template-preview">
                        <span class="template-name">{{ selectedTemplateName }}</span>
                        <span v-html="newSelectedTemplate"></span>
                    </div>

                    <div v-if="parameterCount > 0" id="template-box">
                        <div class="template-item" v-for="el in parametersPreview">
                            <span>Parâmetro {{ el.id + 1 }}: </span>
                            <select class="form-control" v-model="parametersPreview[el.id].type">
                                <option value="customText" selected>Texto</option>
                                <option value="clientName">Nome do Cliente</option>
                                <option value="operatorName">Nome do Operador</option>
                            </select>
                            <input class="form-control" v-model="parametersPreview[el.id].text">
                        </div>
                    </div>

                    <div v-else id="template-box">
                        <span>O template selecionado não possui parâmetros</span>
                    </div>

                    <div id="button-container">
                        <button class="btn widthButton" id="btn-refresh" type="button" :disabled="!toggleTemplateButton"
                            @click.prevent="refreshPreview()"><i class="fa-solid fa-arrows-rotate"></i>
                            Atualizar Template
                        </button>
                        <button class="btn widthButton" id="btn-start" type="button" :disabled="!toggleStartButton"
                            @click.prevent="startConversation()"><i class="fa-solid fa-play"></i>
                            Iniciar Conversa
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
import swal from "sweetalert";
import { mapMutations } from "vuex";

export default {
    props: ['clientName', 'renew', 'btnFinish'],
    name: "StartConversation",
    data: () => ({
        modal: false,
        parameterModal: false,
        allTemplates: [],
        approvedTemplates: [],
        parameterCount: 0,
        parameters: [],
        parametersPreview: [],
        selectedTemplate: '',
        newSelectedTemplate: '',
        selectedTemplateName: '',
        selectedTemplateLanguage: '',
        templateText: '',
        toggleTemplateButton: false,
        toggleStartButton: false,
        check: false,
        searchInput: '',
        items: []
    }),
    methods: {
        ...mapMutations([
            "endCurrentConversaTemplate",
        ]),
        startConversation() {
            this.check = true;
            if (this.parameterCount > 0) {
                if (this.parameters.length > 0) {
                    this.parameters.forEach(el => {
                        if (!el.text) {
                            swal("Por favor, preencha todos os parâmetros do template!", {
                                icon: "warning",
                            });
                            this.check = false;
                        }
                    })
                } else {
                    swal("Por favor, atualize o template!", {
                        icon: "warning",
                    });
                    this.check = false;
                }
            }

            if (this.check) {
                this.$emit('started', {
                    msg: this.newSelectedTemplate,
                    text: this.templateText,
                    name: this.selectedTemplateName,
                    language: this.selectedTemplateLanguage,
                    parameters: this.parameters
                });
                this.check = false;
                this.btnCloseParameter();
            }
        },
        async openTemplateModal() {
            this.check = true;
            if (!this.modal) {
                this.modal = true;
            }
        },
        btnClose() {
            this.modal = false;
        },
        btnCloseParameter() {
            this.parameterModal = false;
        },
        async templateSelect(template) {
            this.selectedTemplateName = template.name;
            this.selectedTemplateLanguage = template.language;
            await this.formatMessage(template);
            this.newSelectedTemplate = this.selectedTemplate;
            this.parameterCount = 0;
            this.parameters = [];
            this.parametersPreview = []
            Object.values(template).forEach(el => {
                if (el) {
                    this.parameterCount = this.parameterCount + (el.match(/{{/g) || []).length;
                }
            })
            if (this.parameterCount > 0) {
                for (let i = 0; i < this.parameterCount; i++) {
                    let objParameter = {
                        id: i,
                        text: '',
                        type: ''
                    }

                    this.parametersPreview.push(objParameter);
                }
            } else {
                this.toggleTemplateButton = false;
                this.toggleStartButton = true;
            }
            this.parameterModal = true;
        },
        async formatMessage(template) {
            if (template.header && template.footer) {
                this.selectedTemplate = `<span><b>${template.header}</b></span><br>
                        <span>${template.body}</span><br>
                        <span style='font-style: italic'>${template.footer}</span>`;
            } else if (template.header && !template.footer) {
                this.selectedTemplate = `<span><b>${template.header}</b></span><br>
                        <span>${template.body}</span><br>`;
            } else if (!template.header && template.footer) {
                this.selectedTemplate = `<span>${template.body}</span><br>
                        <span style='font-style: italic'>${template.footer}</span>`;
            } else {
                this.selectedTemplate = `<span>${template.body}</span><br>`;
            }

            this.templateText = template.body;
            return;
        },
        refreshPreview() {
            this.parameters = [];
            this.newSelectedTemplate = this.selectedTemplate;
            this.parametersPreview.forEach(el => {
                if (el.text) {
                    const parameterId = `{{(${el.id + 1})}}`;
                    const regex = new RegExp(parameterId, "g");

                    if (this.selectedTemplate.match(regex)) {
                        this.newSelectedTemplate = this.newSelectedTemplate.replace(regex, el.text);
                        this.templateText = this.templateText.replace(regex, el.text);
                    }
                }
            })
            this.parameters = this.parametersPreview;
            this.toggleTemplateButton = false;
            this.toggleStartButton = true;
        },
        endCurrChat() {
            this.alertEndChat();
        },
        alertEndChat() {
            let subjectObj = {
                subject: '',
                otherSubject: ''
            }
            return Swal.fire({
                title: "Finalizar atendimento",
                text: "Deseja finalizar o atendimento?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Finalizar",
                cancelButtonText: "Cancelar",
            }).then(async (willDelete) => {
                if (willDelete.value) {
                    await this.endCurrentConversaTemplate();
                    swal("Atendimento finalizado com sucesso", {
                        icon: "success",
                    });
                }
            });
        },
    },
    async mounted() {
        axios.get(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/get_template_list`).then(({ data }) => {
            if (data) {
                this.allTemplates = data;
            }
        });
    },
    computed: {
        type() {
            return this.parametersPreview.map(el => el.type);
        },
        text() {
            return this.parametersPreview.map(el => el.text);
        }
    },
    watch: {
        searchInput() {
            let keyword = this.searchInput.toLowerCase();
            this.items = this.approvedTemplates.filter(row => {
                const name = row.name ? row.name.toLowerCase() : '';
                const header = row.header ? row.header.toLowerCase() : '';
                const body = row.body ? row.body.toLowerCase() : '';
                const footer = row.footer ? row.footer.toLowerCase() : '';
                return (
                    name.includes(keyword) ||
                    header.includes(keyword) ||
                    body.includes(keyword) ||
                    footer.includes(keyword)
                )
            })
        },
        allTemplates() {
            const exampleTemplates = [
                'sample_movie_ticket_confirmation',
                'sample_flight_confirmation',
                'sample_issue_resolution',
                'sample_shipping_confirmation',
                'sample_happy_hour_announcement',
                'hello_world',
                'sample_purchase_feedback'
            ]
            this.allTemplates.forEach(el => {
                let template_obj = {
                    name: '',
                    header: '',
                    body: '',
                    footer: '',
                    language: '',
                }
                if (el.status == 'APPROVED' && !exampleTemplates.includes(el.name)) {
                    template_obj.name = el.name
                    template_obj.language = el.language
                    el.components.forEach(comp => {
                        if (comp.type == 'HEADER') {
                            template_obj.header = comp.text;
                        } else if (comp.type == 'BODY') {
                            template_obj.body = comp.text;
                        } else if (comp.type == 'FOOTER') {
                            template_obj.footer = comp.text
                        }
                    })
                    this.approvedTemplates.push(template_obj);
                }
            })
            this.items = this.approvedTemplates;
        },
        type() {
            this.parametersPreview.forEach(el => {
                if (el.type == 'clientName') {
                    el.text = this.clientName;
                } else if (el.type == 'operatorName') {
                    el.text = user.getName();
                } else {
                    el.text = ''
                }
            })
        },

        text(value) {
            if (this.parameterCount > 0) {
                if (!this.toggleTemplateButton) {
                    this.toggleTemplateButton = true;
                }
                if (this.toggleStartButton) {
                    this.toggleStartButton = false;
                }
            }
        }
    }
}
</script>

<style scoped>
#section-start {
    flex: 2;
    margin: 1em;
    margin-right: 15px;
    height: 3em;
}

#start-button {
    height: 3em;
    border-radius: 0.25em !important;
    background-color: #1c869a;
    color: white;
    font-weight: bold;
}

#finalizar {
    height: 3em;
    border-radius: 0.25em !important;
}

#start-button:hover {
    background-color: #156776;
}

#template-box {
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin: 10px 3px;
    height: 100%;
    overflow-y: auto;
}

.input-search-temp {
    width: 98%;
    border-radius: 5px !important;
}

.modal-head {
    margin-bottom: 0px !important
}

.modal-content-my {
    height: 60vh;
}

.form-modal {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.template-item {
    min-height: 100px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 10px;
    margin: 5px 0px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
}

.template-preview {
    max-height: 120px;
    min-height: 120px;
    overflow-y: auto;
    border: 1px solid lightgray;
    padding: 10px;
    display: flex;
    flex-direction: column;
    margin: 5px;
    border-radius: 5px;
}

.template-item:hover {
    background-color: lightgray
}

.template-item-header {
    font-weight: bold;
    margin: 2px;
}

.template-item-footer {
    font-style: italic;
    margin: 2px;
}

.template-name {
    text-align: center;
    font-weight: bold;
    font-style: italic;
    margin: 2px;
}

.closeBtn:hover {
    color: red;
}

#button-container {
    display: flex;
    justify-content: space-evenly;
}

.modal-2 {
    z-index: 9;
}

#btn-start {
    border: 2px solid white;
    border-radius: 10px !important;
    background-color: #1e862b;
    color: white;
    font-weight: bold;
    transition: 0.25s;
}

#btn-start:hover {
    border: 2px solid #1e862b;
    color: #1e862b;
    background-color: #1e862b5e;
}

#btn-start:disabled {
    border: 1px solid gray;
    color: gray;
    background-color: lightgray;
}

#btn-refresh {
    border: 2px solid white;
    border-radius: 10px !important;
    background-color: #1c869a;
    color: white;
    font-weight: bold;
    transition: 0.25s;
}

#btn-refresh:hover {
    border: 2px solid #1c869a;
    color: #1c869a;
    background-color: #1c869a3b;
}

#btn-refresh:disabled {
    border: 1px solid gray;
    color: gray;
    background-color: lightgray;
}
</style>
